import { NBSP } from 'shared/constants/symbols';

export const UTP = [
  {
    title: `Прямые звонки с${NBSP}платформы`,
    image: 'phone',
  },
  {
    title: `Переадресация от${NBSP}консультантов Циан`,
    image: 'arrows',
  },
  {
    title: `Спецпроекты с${NBSP}девелоперами`,
    image: 'buildings',
  },
];

export const WHITE_UTP = [
  {
    title: `Прозрачность расчётов`,
    image: 'document',
  },
  {
    title: `Контроль бюджета`,
    image: 'shield',
  },
  {
    title: `Реальная отдача от${NBSP}размещения`,
    image: 'chart',
  },
];
